export const bookingOptions = [
  { value: "CONSULTATION", label: "Consultation" },
  { value: "TREATMENT", label: "Treatment" },
  { value: "FOLLOW_UP", label: "Follow-up" },
];
